module.exports = __webpack_public_path__ + "img/IMG-20200226-WA0011.09af3ae9.jpg";